import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiButton' })(
  ({ brandColors, type, breakpoints, typography }) => ({
    button: {
      display: 'flex',
      alignItems: 'center',
      ...type['16_medium'],
      margin: 0,
    },

    defaultButton: {
      height: typography.pxToRem(60),
      maxHeight: '100%',
      borderRadius: typography.pxToRem(800),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: `0 ${typography.pxToRem(24)}`,
      border: 'none',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
    },
    PrimaryBluePill: {
      backgroundColor: brandColors.primaryMain,
      color: brandColors.white,
    },
    TransparentPillArrowLight: {
      backgroundColor: 'transparent',
      color: brandColors.white,
      border: `2px solid ${brandColors.white}`,
      gap: typography.pxToRem(18),
      textDecoration: 'none',
      ...type['16_medium'],
    },
    TransparentPillArrowPrimary: {
      backgroundColor: 'transparent',
      color: brandColors.primaryMain,
      border: `2px solid ${brandColors.primaryMain}`,
      gap: typography.pxToRem(18),
      textDecoration: 'none',
      ...type['16_medium'],
    },
    WhitePill: {
      backgroundColor: brandColors.white,
      color: brandColors.primaryMain,
    },
    OffWhitePill: {
      backgroundColor: brandColors.offWhite,
      color: brandColors.primaryMain,
    },
    OffWhitePillPrimaryBlueOutline: {
      backgroundColor: brandColors.offWhite,
      color: brandColors.primaryMain,
      border: `2px solid ${brandColors.primaryMain}`,
    },
    OffWhiteCircleArrow: {
      backgroundColor: brandColors.offWhite,
      color: brandColors.primaryMain,
      height: typography.pxToRem(64),
      width: typography.pxToRem(64),
    },
    offWhiteCircleLabel: {
      marginLeft: typography.pxToRem(20),
      fontWeight: 500,
      fontSize: typography.pxToRem(28),
      lineHeight: typography.pxToRem(36),
      letterSpacing: '-0.02rem',
      color: brandColors.offWhite,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontWeight: 400,
        fontSize: typography.pxToRem(24),
      },
    },
    TransparentPillPrimaryBlueOutline: {
      backgroundColor: 'transparent',
      color: brandColors.primaryMain,
      border: `2px solid ${brandColors.primaryMain}`,
    },
    TransparentPillWhiteOutline: {
      backgroundColor: 'transparent',
      color: brandColors.white,
      border: `1px solid ${brandColors.white}`,
      textDecoration: 'none',
    },
    TransparentPrimaryBlueText: {
      backgroundColor: 'transparent',
      color: brandColors.primaryMain,
      textDecoration: 'none',
    },
    TransparentWhiteText: {
      backgroundColor: 'transparent',
      color: brandColors.white,
      textDecoration: 'none',
    },
    ArrowOnlyOffWhite: {
      backgroundColor: brandColors.offWhite,
      color: brandColors.primaryMain,
      padding: 0,
      height: 'auto',
    },

    defaultDisabled: {
      backgroundColor: 'white',
      color: brandColors.gray,
      border: `2px solid ${brandColors.gray}`,
      cursor: 'default',
      pointerEvents: 'none',
    },
    PrimaryBluePillDisabled: {},
    TransparentPillArrowPrimaryDisabled: {},
    TransparentPillArrowLightDisabled: {},
    WhitePillDisabled: {},
    OffWhitePillDisabled: {},
    OffWhitePillPrimaryBlueOutlineDisabled: {},
    OffWhiteCircleArrowDisabled: {},
    offWhiteCircleLabelDisabled: {},
    TransparentPillPrimaryBlueOutlineDisabled: {},
    TransparentPillWhiteOutlineDisabled: {},
    TransparentPrimaryBlueTextDisabled: {},
    TransparentWhiteTextDisabled: {},
    ArrowOnlyOffWhiteDisabled: {
      padding: 0,
      height: 'auto',
    },
    Arrow: {
      backgroundColor: brandColors.primaryMain,
      height: '19px',
      padding: '1rem 0.3rem',
    },
    ArrowDisabled: {
      padding: 0,
      height: 'auto',
    },
  })
);

export default useStyles;
